var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3945 27.4555L17.4893 30.7085C18.2158 31.2642 19.1008 31.5488 19.999 31.5217H25.0185C26.7224 31.481 28.2019 30.3425 28.717 28.6754L31.8872 18.7811C32.4287 17.4935 31.8343 16.0026 30.5795 15.4469C30.1964 15.2843 29.7869 15.2165 29.3775 15.2572H24.0938C23.3541 15.2572 22.7597 14.6608 22.7465 13.9018C22.7465 13.8069 22.7465 13.7256 22.7729 13.6307L23.4334 9.2935C23.6447 8.0059 22.9182 6.7454 21.7162 6.31168C20.6463 5.95928 19.4839 6.33878 18.8102 7.26044L13.3945 15.5282",
    stroke: "#19FB80",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66016 27.469V14.1863C6.66016 12.2888 7.4527 11.6111 9.30196 11.6111H10.6229C12.4721 11.6111 13.2647 12.2888 13.2647 14.1863V27.469C13.2647 29.3665 12.4721 30.0442 10.6229 30.0442H9.30196C7.4527 30.0442 6.66016 29.3665 6.66016 27.469V27.469Z",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFun);
export default __webpack_public_path__ + "static/media/Fun.1c293362f24f5324b54904290a38bc41.svg";
export { ForwardRef as ReactComponent };